(function () {
  const mql = window.matchMedia('(max-width: 767px)');

  // 要素は毎回DOMから引き直す。素材の絞り込みでギャラリーが作り直されても古い要素を掴んだままにならない
  function parts() {
    const container = document.querySelector('.product-media-progress');
    if (!container) return null;
    const track = container.querySelector('.product-media-progress__track');
    const bar = container.querySelector('.product-media-progress__bar');
    const gutter = container.closest('slider-component');
    const slider = gutter && gutter.querySelector('.product__media-list');
    if (!track || !bar || !slider) return null;
    return { container: container, track: track, bar: bar, slider: slider };
  }

  // 現在のスクロール位置を返す。対象が無ければ -1（追従ループの停止条件を兼ねる）
  function update() {
    if (!mql.matches) return -1;
    const p = parts();
    if (!p) return -1;

    const count = p.slider.querySelectorAll('.product__media-item').length;
    if (count < 2) {
      p.container.style.display = 'none';
      return -1;
    }
    p.container.style.display = '';
    p.bar.style.width = 100 / count + '%';

    const maxScroll = p.slider.scrollWidth - p.slider.clientWidth;
    const ratio = maxScroll > 0 ? p.slider.scrollLeft / maxScroll : 0;
    // %指定だと丸めた幅を基準に動いてしまい最後の1枚で右にはみ出すので、移動量はpxで出す
    p.bar.style.transform = 'translateX(' + ratio * (p.track.clientWidth - p.bar.clientWidth) + 'px)';
    return p.slider.scrollLeft;
  }

  // iOSはタッチ/慣性スクロール中にscrollイベントを間引くので、動いている間だけrAFで位置を追う
  let raf = 0;
  let lastScrollLeft = -1;
  function tick() {
    const now = update();
    if (now === lastScrollLeft) {
      raf = 0;
      return;
    }
    lastScrollLeft = now;
    raf = requestAnimationFrame(tick);
  }
  function follow() {
    if (raf) return;
    lastScrollLeft = -1;
    raf = requestAnimationFrame(tick);
  }

  function inSlider(event) {
    return event.target instanceof Element && event.target.closest('.product__media-list');
  }

  // scrollはバブルしないのでキャプチャで拾う。要素ごとに貼らないので差し替えられても貼り直しが要らない
  document.addEventListener('scroll', function (e) { if (inSlider(e)) follow(); }, true);
  document.addEventListener('touchstart', function (e) { if (inSlider(e)) follow(); }, { passive: true });
  document.addEventListener('touchmove', function (e) { if (inSlider(e)) follow(); }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  mql.addEventListener('change', update);
  // 素材切替でギャラリーが差し替わったら数え直す
  document.addEventListener('starapps:variant:change', update);
})();
